(function () {
  var playlists = [];
  var playlistIndex = 0;
  var trackIndex = 0;
  var howl = null;
  var playing = false;
  var volume = 0.7;
  var listeners = {
    change: []
  };

  function getCurrentPlaylist() {
    return playlists[playlistIndex] || null;
  }

  function getCurrentTrack() {
    var playlist = getCurrentPlaylist();

    if (!playlist || !playlist.tracks || !playlist.tracks.length) {
      return null;
    }

    return playlist.tracks[trackIndex] || playlist.tracks[0] || null;
  }

  function getTrackSrc(track) {
    if (!track) {
      return '';
    }

    return track.src || track.url || '';
  }

  function emit(eventName) {
    var state = Player.getState();

    if (!listeners[eventName]) {
      return;
    }

    listeners[eventName].forEach(function (callback) {
      if (typeof callback === 'function') {
        callback(state);
      }
    });
  }

  function unloadCurrentHowl() {
    if (howl) {
      howl.unload();
      howl = null;
    }
  }

  function createHowl(track) {
    var src = getTrackSrc(track);

    if (!src || typeof Howl === 'undefined') {
      return null;
    }

    unloadCurrentHowl();

    howl = new Howl({
      src: [src],
      html5: true,
      preload: false,
      volume: volume,
      onplay: function () {
        playing = true;
        emit('change');
      },
      onpause: function () {
        playing = false;
        emit('change');
      },
      onstop: function () {
        playing = false;
        emit('change');
      },
      onend: function () {
        Player.next(true);
      },
      onloaderror: function (id, error) {
        console.warn('TR Radio: track failed to load.', error, track);
      },
      onplayerror: function (id, error) {
        console.warn('TR Radio: track failed to play.', error, track);

        if (howl && typeof howl.once === 'function') {
          howl.once('unlock', function () {
            howl.play();
          });
        }
      }
    });

    return howl;
  }

  var Player = {
    init: function (nextPlaylists) {
      playlists = Array.isArray(nextPlaylists) ? nextPlaylists : [];
      playlistIndex = 0;
      trackIndex = 0;
      playing = false;

      unloadCurrentHowl();
      emit('change');
    },

    getState: function () {
      return {
        playlists: playlists,
        playlist: getCurrentPlaylist(),
        playlistIndex: playlistIndex,
        track: getCurrentTrack(),
        trackIndex: trackIndex,
        playing: playing,
        volume: volume
      };
    },

    on: function (eventName, callback) {
      if (!listeners[eventName]) {
        listeners[eventName] = [];
      }

      listeners[eventName].push(callback);
    },

    play: function (nextPlaylistIndex, nextTrackIndex) {
  if (typeof nextPlaylistIndex === 'number') {
    playlistIndex = nextPlaylistIndex;
  }

  if (typeof nextTrackIndex === 'number') {
    trackIndex = nextTrackIndex;
  }

  var track = getCurrentTrack();
  var src = getTrackSrc(track);

  console.log('TR Radio play requested:', {
    playlistIndex: playlistIndex,
    trackIndex: trackIndex,
    track: track,
    src: src,
    hasHowl: typeof Howl !== 'undefined'
  });

  if (!track || !src) {
    console.warn('TR Radio: no track/src available.', track);
    return;
  }

  createHowl(track);

  if (!howl) {
    console.warn('TR Radio: Howl was not created.');
    return;
  }

  var soundId = howl.play();

  console.log('TR Radio howl.play() called:', {
    soundId: soundId,
    playing: howl.playing(soundId),
    state: howl.state(),
    duration: howl.duration()
  });
},

    pause: function () {
      if (howl) {
        howl.pause();
      }

      playing = false;
      emit('change');
    },

    toggle: function () {
      if (playing) {
        Player.pause();
      } else {
        Player.play(playlistIndex, trackIndex);
      }
    },

    prev: function () {
      var playlist = getCurrentPlaylist();

      if (!playlist || !playlist.tracks || !playlist.tracks.length) {
        return;
      }

      trackIndex = trackIndex <= 0 ? playlist.tracks.length - 1 : trackIndex - 1;
      Player.play(playlistIndex, trackIndex);
    },

    next: function () {
      var playlist = getCurrentPlaylist();

      if (!playlist || !playlist.tracks || !playlist.tracks.length) {
        return;
      }

      trackIndex = trackIndex >= playlist.tracks.length - 1 ? 0 : trackIndex + 1;
      Player.play(playlistIndex, trackIndex);
    },

    volume: function (nextVolume) {
      volume = Math.max(0, Math.min(1, Number(nextVolume)));

      if (howl) {
        howl.volume(volume);
      }

      emit('change');
    },

    progress: function () {
      if (!howl || !howl.duration()) {
        return 0;
      }

      return howl.seek() / howl.duration();
    },

    seek: function (ratio) {
      if (!howl || !howl.duration()) {
        return;
      }

      howl.seek(howl.duration() * ratio);
      emit('change');
    },

    getHowl: function () {
      return howl;
    }
  };

   window.Player = Player;
   
   
})();

if (typeof TR_PLAYLISTS !== 'undefined') {
  Player.init(TR_PLAYLISTS);
  Player.volume(0.7);
  Player.play(0, 0);
}